import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractServicePrivate } from './abstract.service.private';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractCrudService extends AbstractServicePrivate {

  listar(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}`);
  }

  procurarPorId(entityId: number | string): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/${entityId}`);
  }

  criar(entity: Object): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPrivate()}`, entity);
  }

  atualizar(value: any, entityId?: number | string): Observable<Object> {
    if (entityId) {
      return this.http.put(`${this.getBaseUrlPrivate()}/${entityId}`, value);
    } else {
      return this.http.put(`${this.getBaseUrlPrivate()}`, value);
    }
  }

  remover(entityId: number | string): Observable<any> {
    return this.http.delete(`${this.getBaseUrlPrivate()}/${entityId}`, { responseType: 'text' });
  }
}
